import React from "react"
import CardTree from "../CardTree"
import GrowthCard from "../GenerateGrowthNode"
import { SWITCHING_NODE } from "components/CustomerBehavior/Switching/SwitchingBreakdown/components/SwitchingTree/configurationTree"
import { IntlShape } from "react-intl"

const checkPositioning = (nodeDatum: any, foreignObjectProps: any) => {
	const { id } = nodeDatum
	const factorPositionForeignYFatherNode = -55
	return id === "total"
		? { ...foreignObjectProps, y: factorPositionForeignYFatherNode }
		: foreignObjectProps
}

const GenerateNode = (
	{ nodeDatum, toggleNode, foreignObjectProps }: any,
	category: string,
	intl: IntlShape
) => (
	<g onClick={toggleNode}>
		{category === SWITCHING_NODE ? (
			<foreignObject {...checkPositioning(nodeDatum, foreignObjectProps)}>
				<CardTree nodeDatum={nodeDatum} />
			</foreignObject>
		) : (
			<foreignObject {...foreignObjectProps}>
				<GrowthCard nodeDatum={nodeDatum} intl={intl} />
			</foreignObject>
		)}
	</g>
)

export default GenerateNode
